/**
 * Markenzeichen in der Seitenleiste.
 *
 * HVACloud: eingebautes SVG mit semantischen Tokens, passt sich hell/dunkel
 * von selbst an. Fremdmarke (BRAND.logo gesetzt): Bilddatei aus
 * /brand/<id>/, je nach Thema die Zeichnung fuer dunkle oder helle Flaechen.
 * Farben des HVACloud-Zeichens stammen aus docs/branding/HVACloudLogo.dc.html.
 */
import { BRAND } from '../brand/brand';
import { themeSignal } from '../theme/theme';

export function Logo({ withText = true, height = 28 }: { withText?: boolean; height?: number }) {
  if (BRAND.logo) {
    const src = themeSignal.value === 'light' ? BRAND.logo.onLight : BRAND.logo.onDark;
    const width = Math.round(height * BRAND.logo.aspect);
    return (
      <img
        class="hv-brand-logo"
        src={src}
        width={width}
        height={height}
        alt={BRAND.productName}
        style={{ display: 'block', height: `${height}px`, width: `${width}px` }}
      />
    );
  }

  const width = withText ? Math.round((height / 200) * 340) : Math.round((height / 200) * 340 * 0.6);
  return (
    <svg
      viewBox={withText ? '0 0 340 200' : '30 40 280 130'}
      width={width}
      height={height}
      role="img"
      aria-label={BRAND.productName}
      style={{ display: 'block' }}
    >
      <g fill="var(--text-secondary)">
        <rect x="42" y="110" width="260" height="66" rx="33" />
        <circle cx="172" cy="86" r="56" />
        <circle cx="104" cy="108" r="44" />
        <circle cx="240" cy="108" r="44" />
      </g>
      {withText && (
        <text
          x="172"
          y="144"
          text-anchor="middle"
          font-family="var(--font-sans)"
          font-weight="800"
          font-size="39"
          letter-spacing="-1"
        >
          <tspan fill="var(--accent)">HVAC</tspan>
          <tspan fill="var(--text-primary)">loud</tspan>
        </text>
      )}
    </svg>
  );
}
